import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Address, LatLng } from 'api/public/place/types';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { RootState } from 'shared/redux/store';
import { PlaceState } from './types';

const initialState: PlaceState = {
  gps_detecting: false,
  my_location: {
    first_label: '7A/28 Đ. Thành Thái',
    second_label: ' Phường 14, Quận 10, Hồ Chí Minh, Việt Nam',
    address: '7A/28 Đ. Thành Thái, Phường 14, Quận 10, Hồ Chí Minh, Việt Nam',
    lat: 10.769408,
    lng: 106.6633236,
    short_address: '7A/28 Đ. Thành Thái',
    adr_source: 'google',
    description: '7A/28 Đ. Thành Thái, Phường 14, Quận 10, Hồ Chí Minh',
    types: ['street_address'],
    geometry: {
      coordinates: [106.6633236, 10.769408],
      type: 'Point',
    },
  },
};

export const placeSlice = createSlice({
  name: 'placeSlice',
  initialState,
  reducers: {
    updateMyLocation(state, action: PayloadAction<Address | undefined>) {
      state.my_location = action.payload;
    },
    setGPSDetecting(state, action: PayloadAction<boolean>) {
      state.gps_detecting = action.payload;
    },
    setGPSLatLng(state, action: PayloadAction<LatLng | undefined>) {
      state.gps_latLng = action.payload;
    },
  },
});

export const placeReducer = persistReducer(
  {
    key: 'place',
    storage,
    whitelist: ['my_location'],
  },
  placeSlice.reducer
);

// SELECTOR
export const selectGPSDetecting = (state: RootState) =>
  state.placeSlice.gps_detecting;
export const selectGPSLatLng = (state: RootState) =>
  state.placeSlice.gps_latLng;
export const selectMyLocation = (state: RootState) =>
  state.placeSlice.my_location;
